var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGuarantee(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 291.638 291.638",
    xmlSpace: "preserve",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#ffffff"
    },
    cx: 164.57,
    cy: 126.923,
    r: 65.625
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3F62A3"
    },
    d: "M261.934,19.111c-32.906,0-65.076-6.197-95.62-18.412L164.57,0l-1.739,0.698 C132.283,12.914,100.112,19.11,67.206,19.11H56.757v98.438H33.32c-7.753,0-14.062,6.309-14.062,14.062v79.688 c0,7.753,6.309,14.063,14.062,14.063h42.187c0.009,0,0.014,0,0.023,0c11.072,17.592,26.414,32.123,44.705,42.094l44.334,24.183 l44.334-24.183c39.159-21.356,63.478-62.33,63.478-106.931V19.111H261.934z M28.632,211.298V131.61c0-2.583,2.1-4.687,4.687-4.687 h42.187c2.587,0,4.687,2.105,4.687,4.687v79.688c0,2.583-2.1,4.688-4.687,4.688H33.32 C30.732,215.986,28.632,213.881,28.632,211.298z M89.57,140.944c15.652-0.848,28.125-13.852,28.125-29.709V87.08 c0-6.459,5.255-11.719,11.719-11.719s11.719,5.259,11.719,11.719v29.503c0,8.287,6.741,15.028,15.028,15.028h34.364 c8.948,0,16.233,7.28,16.233,16.233v51.909c0,8.953-7.284,16.233-16.233,16.233h-69.066c-3.722,0-7.172-1.852-9.239-4.945 c-3.806-5.709-10.177-9.117-17.039-9.117h-5.611L89.57,140.944L89.57,140.944z M263.007,160.523 c0,41.166-22.448,78.989-58.589,98.7l-39.848,21.736l-39.848-21.736c-16.308-8.897-30.089-21.708-40.223-37.205 c2.845-2.391,4.716-5.859,4.978-9.797c9.459,16.317,23.081,29.686,39.736,38.77l35.358,19.289l35.358-19.289 c33.127-18.066,53.705-52.73,53.705-90.464V89.423h-9.375v71.105c0,34.298-18.703,65.813-48.816,82.233l-30.872,16.838 l-30.872-16.838c-13.209-7.205-24.305-17.386-32.644-29.705c1.308,0.82,2.48,1.861,3.366,3.188 c3.806,5.709,10.177,9.117,17.039,9.117h69.066c14.123,0,25.608-11.489,25.608-25.608v-51.909 c0-14.119-11.484-25.608-25.608-25.608h-34.364c-3.117,0-5.653-2.536-5.653-5.653V87.08c0-11.63-9.464-21.094-21.094-21.094 c-11.63,0-21.094,9.464-21.094,21.094v24.15c0,10.688-8.292,19.378-18.769,20.217c-0.047-4.073-1.852-7.702-4.669-10.242V46.697 c27.225-1.673,54.005-7.237,79.687-16.566c25.683,9.328,52.458,14.892,79.687,16.566v5.227h9.375V37.777l-4.472-0.206 c-28.378-1.298-56.292-6.961-82.964-16.828l-1.627-0.605l-1.627,0.6c-26.677,9.867-54.591,15.53-82.964,16.828l-4.472,0.211 v79.772h-9.375V28.486h1.073c33.483,0,66.225-6.188,97.364-18.394c31.139,12.206,63.881,18.394,97.364,18.394h1.073v132.037 H263.007z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244.257,
    y: 70.673,
    style: {
      fill: "#6415ff"
    },
    width: 9.375,
    height: 9.375
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38.007,
    y: 197.236,
    style: {
      fill: "#6415ff"
    },
    width: 32.812,
    height: 9.375
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuarantee);
export default __webpack_public_path__ + "static/media/guarantee.28a0aa67dfc7320207f52dbea520043f.svg";
export { ForwardRef as ReactComponent };